import globalRequestReserve from '@/views/reserves'

import { storage } from '@/services/storage'

var routes = [
	{
		path: '/reservas/:deal?',
		name: 'global.request.reserve',
		component: globalRequestReserve,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Solicitar Reserva',
			protect: true,
			iframe: true
		},
	},
]

export { routes }
